import { BRAND_NAME, DEMO_URL, CONTACT_EMAIL, LEGAL_LINE } from "@/config";

export const Footer = () => (
  <footer className="bg-ink text-sage/70 py-12 md:py-16">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10 pb-12 border-b border-sage/15">
        <div>
          <p className="font-serif text-3xl md:text-4xl text-sage">
            {BRAND_NAME}<span className="text-green">.</span>
          </p>
          <p className="mt-3 max-w-sm text-sage/60">
            Where Christian communities gather, grow, and keep a record of what
            God is doing.
          </p>
        </div>
        <nav className="flex flex-wrap items-center gap-x-8 gap-y-3">
          <a href="https://www.wordamp.com" target="_blank" rel="noopener noreferrer" data-testid="footer-home" className="hover:text-sage transition-colors duration-300">wordamp.com</a>
          <a href={DEMO_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-demo" className="hover:text-sage transition-colors duration-300">Demo</a>
          <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-contact" className="hover:text-sage transition-colors duration-300">Contact</a>
        </nav>
      </div>

      <div className="pt-8 space-y-4 text-sm text-sage/50">
        <p className="max-w-3xl leading-relaxed">
          Scripture: Berean Standard Bible (public domain), World English Bible
          (public domain), and King James Version. Lexical data from
          STEPBible.org, Tyndale House Cambridge, CC BY 4.0.
        </p>
        <p>{LEGAL_LINE}</p>
      </div>
    </div>
  </footer>
);
